// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 169) return "static/js/LiveGamesContent.6a228c3790bde4b623b1.chunk.js";
	if (chunkId === 707) return "static/js/CategoryDetails.ba13d9f7390de4e0dbb7.chunk.js";
	if (chunkId === 225) return "static/js/MainNavigation.fd0fc4d57f577b6de6d4.chunk.js";
	if (chunkId === 597) return "static/js/BingoGames.8ce63cc2a7a0a9c5a4d5.chunk.js";
	if (chunkId === 237) return "static/js/GameDetails.041f10fb18c34e719911.chunk.js";
	if (chunkId === 112) return "static/js/GameDetailsContent.9e01c5b47968e21bffcf.chunk.js";
	if (chunkId === 455) return "static/js/SearchCategory.9a484ca61191c38dc5cd.chunk.js";
	if (chunkId === 94) return "static/js/SearchMoreResults.8d9a623777d482b8fc2f.chunk.js";
	if (chunkId === 86) return "static/js/SimplifiedHeader.51cdfb29507dab3bea43.chunk.js";
	if (chunkId === 660) return "static/js/SearchHeader.16811207823aff5ca1d6.chunk.js";
	if (chunkId === 265) return "static/js/SearchHistory.628832f183b52e2f0ef1.chunk.js";
	if (chunkId === 606) return "static/js/ErrorPage.c0d40374774894ccc70a.chunk.js";
	if (chunkId === 32) return "static/js/GameModal.33244349f17d99914b8c.chunk.js";
	if (chunkId === 700) return "static/js/Copy.36cb63752d10dab22a52.chunk.js";
	if (chunkId === 990) return "static/js/FloatingIcon.384f9a0f59dc6da0e8ab.chunk.js";
	if (chunkId === 620) return "static/js/ErrorContainer.a191e0058b6c66d79dc4.chunk.js";
	if (chunkId === 347) return "static/js/CookieBanner.78da7fdc6acc85d36a12.chunk.js";
	if (chunkId === 430) return "static/js/Menu.dd6ec441d9c7ae751d30.chunk.js";
	if (chunkId === 896) return "static/js/SearchWrapper.65d096dfc7657932bf5a.chunk.js";
	if (chunkId === 499) return "static/js/Download.3d29d21b414ad61b6177.chunk.js";
	if (chunkId === 410) return "static/js/SearchSuggestions.fb344a904e453b4d1f84.chunk.js";
	if (chunkId === 356) return "static/js/Steps.6221644c5ec2897093af.chunk.js";
	if (chunkId === 496) return "static/js/BannerStandalone.682319236cf74e9a297a.chunk.js";
	if (chunkId === 207) return "static/js/VideoModal.8d1e29bffefedeee590c.chunk.js";
	if (chunkId === 29) return "static/js/ProvidersFilter.7711a56b04adc5ed122e.chunk.js";
	if (chunkId === 401) return "static/js/IdlePopup.a8a687da12f5ccb5ea25.chunk.js";
	if (chunkId === 152) return "static/js/JackpotDrawer.63b1d833507215b77a98.chunk.js";
	if (chunkId === 167) return "static/js/JackpotWidget.757d51d75e6cc260cbb9.chunk.js";
	if (chunkId === 899) return "static/js/GameBanner.d1e3079bf00b9c07fa9c.chunk.js";
	if (chunkId === 843) return "static/js/GameDual.8ed69b620d4783942e78.chunk.js";
	if (chunkId === 349) return "static/js/GameList.694c3995821a8a6a7e77.chunk.js";
	if (chunkId === 827) return "static/js/Grid.e75e8695ac5ebf0fe88d.chunk.js";
	if (chunkId === 160) return "static/js/ExtendedGrid.5f82c1c91f8c2d2f1f97.chunk.js";
	if (chunkId === 659) return "static/js/WidgetGrid.8865f3e6d04390f1983b.chunk.js";
	if (chunkId === 737) return "static/js/GameGridSearch.58e76f4bf5138be18ef8.chunk.js";
	if (chunkId === 102) return "static/js/JackpotWidgetPrizeAreaDesktop.c58615168e3717516c7c.chunk.js";
	if (chunkId === 668) return "static/js/JackpotWidgetPrizeAreaMobile.50ed8f3af6555d722b0e.chunk.js";
	if (chunkId === 41) return "static/js/GameTileSearch.78e75ea98fee1a6bd63d.chunk.js";
	// return url for filenames based on template
	return undefined;
};